import React from "react"
import { Link } from "react-router-dom"
import { useRecoilState } from "recoil"
import { sizeState, userObjState } from "../recoil-atom"

import { Flex } from "../styled-components-openmark"
// import styled from "styled-components"

const Footer = () => {
  const [size, setSize] = useRecoilState(sizeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)

  return (
    <>
      <div className="footer">
        <Flex width={size.appWidth}>
            <div className="footer-link">
              <Link to="/usage">사용안내</Link>
            </div>
          <div className="footer-link">
            <a href="mailto:jacealan1@gmail.com">문의·제안</a>
          </div>
          <div>&copy; Jace {new Date().getFullYear()}</div>
        </Flex>
        {userObj && userObj.email === "jacealan1@gmail.com" && (
          <Flex width={size.appWidth}>
            <div className="footer-link">
              <Link to="/sample">예제페이지</Link>
            </div>
            <div className="footer-link">
              <Link to="#">예제 만들기</Link>
            </div>{" "}
            <div className="footer-link">
              <Link to="/about">Jace소개</Link>
            </div>
            <div className="footer-link">
              <a
                href="https://docs.google.com/spreadsheets/d/1KK-mWXM8azBGLWzzzypDsjZgkwFT0CafBmJNOhEmmtQ/edit?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                Reviews
              </a>
            </div>
          </Flex>
        )}
        <Flex width={size.appWidth}></Flex>
      </div>

      <style jsx>{`
        .footer {
          /* overflow: hidden; */
          width: ${size.appWidth}px;
          /* min-height: 150px; */
          margin: 10px auto;
          border-top: solid 1px #ddd;
          padding: 10px 20px 20px 20px;
          color: #999;
        }

        .footer-link {
          min-width: 90px;
          /* margin-right: 20px; */
        }
      `}</style>
    </>
  )
}

export default Footer
